import { useState } from "react";
import { Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Admin-only (director/administrator) soft-delete affordance. Renders nothing for
// other roles. `endpoint` is the DELETE URL (e.g. `/forms/instances/{id}`).
export default function AdminDeleteButton({ endpoint, label = "record", onDeleted, testId, variant = "icon", confirmText }) {
    const { user } = useAuth();
    const [busy, setBusy] = useState(false);
    if (!user || !["director", "administrator"].includes(user.role)) return null;

    const doDelete = async (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        if (!window.confirm(confirmText || `Delete this ${label}? It will be removed from all views (recoverable by an administrator).`)) return;
        setBusy(true);
        try {
            await api.delete(endpoint);
            toast.success(`${label.charAt(0).toUpperCase() + label.slice(1)} deleted`);
            if (onDeleted) onDeleted();
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail) || "Delete failed");
        }
        setBusy(false);
    };

    if (variant === "button") {
        return (
            <button data-testid={testId} onClick={doDelete} disabled={busy}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 text-[13px] font-semibold rounded-lg border border-red-200 text-red-700 hover:bg-red-50 disabled:opacity-60">
                {busy ? <Loader2 className="animate-spin" size={13} /> : <Trash2 size={13} />} Delete
            </button>
        );
    }
    return (
        <button data-testid={testId} onClick={doDelete} disabled={busy} title={`Delete ${label}`}
            className="p-1.5 rounded-lg text-red-600 hover:bg-red-50 disabled:opacity-60 shrink-0">
            {busy ? <Loader2 className="animate-spin" size={14} /> : <Trash2 size={14} />}
        </button>
    );
}
